module.exports = [{
      plugin: require('/home/andrew/Repos/andrewpattison.dev/node_modules/gatsby-plugin-google-analytics/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('/home/andrew/Repos/andrewpattison.dev/node_modules/gatsby-plugin-offline/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('/home/andrew/Repos/andrewpattison.dev/node_modules/gatsby-plugin-typography/gatsby-browser.js'),
      options: {"plugins":[],"pathToConfigModule":"src/utils/typography"},
    },{
      plugin: require('/home/andrew/Repos/andrewpattison.dev/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
